import { parseBatchTokens } from '@/temu-platform/modules/products/components/batchQueryUtils';

/** 模板名称是否命中任一批量 token（大小写不敏感，包含匹配）。 */
export function matchTemplateName(rowName, keywordOrTokens) {
  const tokens = Array.isArray(keywordOrTokens)
    ? keywordOrTokens.map((t) => String(t || '').trim().toLowerCase()).filter(Boolean)
    : parseBatchTokens(keywordOrTokens).map((t) => t.toLowerCase());
  if (!tokens.length) return true;
  const name = String(rowName || '').trim().toLowerCase();
  if (!name) return false;
  return tokens.some((t) => name.includes(t));
}

export function templateNameTokens(keyword) {
  return parseBatchTokens(keyword);
}
